module.exports = __webpack_public_path__ + "img/server.13f963fd.jpg";